import { Flex, Text } from '@chakra-ui/react';

import { ContentContainer } from '~/components/container';
import { ICON_SIZE, StarIcon } from '~/features/experiments/ab_plp_redesign_2025/icons';
import type { ProgramReview } from '~/features/program/models/program-review';

import { formatCountLabel } from '../utils/format-count-label';

import { CardCarousel, CarouselTitle } from './card-carousel';
import { ReviewCard } from './review-card';

export type TrustpilotReviewsSubsectionProps = {
  reviews: ProgramReview[];
  numberOfReviews: number;
  starsAverage: number;
  onArrowClick: () => void;
};

const CARD_WIDTH = 220;

export function TrustpilotReviewsSubsection({
  reviews,
  numberOfReviews,
  starsAverage,
  onArrowClick,
}: TrustpilotReviewsSubsectionProps) {
  if (reviews.length === 0) return null;

  return (
    <ContentContainer>
      <CardCarousel
        label='reviews'
        title={<CarouselTitle ariaLabel='Trustpilot feedback'>Trustpilot reviews</CarouselTitle>}
        meta={
          <Flex alignItems='center' gap='6px'>
            <StarIcon color='primary.orange' flexShrink={0} height={ICON_SIZE} width={ICON_SIZE} />
            <Text as='b' color='supportOrange.70' fontSize='md' fontWeight='600' lineHeight='md'>
              Average Rating: {starsAverage}{' '}
              <Text as='span' color='supportGray.100' fontSize='md' fontWeight='400' lineHeight='md'>
                ({formatCountLabel(numberOfReviews, 'Review')})
              </Text>
            </Text>
          </Flex>
        }
        slides={reviews.map((review, idx) => ({
          key: review.createdAt + idx,
          content: <ReviewCard review={review} width={`${CARD_WIDTH}px`} />,
        }))}
        onArrowClick={onArrowClick}
      />
    </ContentContainer>
  );
}
